import React from 'react';
import styled from 'styled-components';

import { CtaButton, SectionHeadline } from '../styled';

const Container = styled.div`
  padding: 0 25px;
`

const HomepageHeroInner = styled.div`
  max-width: 990px;
  padding: 44px 0 50px;
  margin: 0 auto;
  text-align: center;
  border-radius: 12px;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.06);
  margin-bottom: 50px;
`;

const Headline = styled(SectionHeadline)`
  max-width: 680px;
  margin: 0 auto;
  margin-bottom: 16px;
`;

const Subheadline = styled.div`
  color: #666666;
  max-width: 480px;
  margin: 0 auto;
  font-size: 18px;
  line-height: 22px;
  font-weight: 400;
  letter-spacing: 0.54px;
`;

const MainImage = styled.div`
  img {
    height: 210px;
    margin-bottom: 40px;
    border-radius: 210px;
  }
`;

const PrimaryCtaButton = styled(CtaButton)`
  background: #1e5cb3;
  color: #ffffff;
  margin-top: 32px;

  &:hover {
    background: #3f81df;
  }

  &:active {
    background: #133a71;
  }
`;

function HomepageHero({ input }) {
  return (
    <Container>
      <HomepageHeroInner>
        <MainImage><img src={input.primary.image.url} /></MainImage>
        <Headline>{input.primary.headline.text}</Headline>
        <Subheadline>{input.primary.subheadline.text}</Subheadline>
       
      </HomepageHeroInner>
    </Container>
  );
}

export { HomepageHero };
